"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLogContext = void 0;
const global_1 = require("./global");
const constants_1 = require("./constants");
const withLogContext = (context, fn) => {
    const contextManager = (0, global_1.getGlobal)(constants_1.GLOBAL_CONTEXT_MANAGER_KEY);
    return contextManager ? contextManager.with(context, fn) : fn();
};
exports.withLogContext = withLogContext;
//# sourceMappingURL=context.js.map